// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';

type Props = {
  height: ?string;
};

export default styled<any, Theme, Props>('div')`
  display: inline-block;
  position: relative;

  ${props => props.height && css`
    height: ${props.height};
  `}
`;
